import React, { useState, useTransition } from 'react'
import { FormItem } from '@/components/Form'
import { TextField, Typography, Tooltip, Box } from '@material-ui/core'
import UpdateIcon from './UpdateIcon'
import { HelpOutline } from '@material-ui/icons'
import { useTranslation } from '@/langs/useTranslation'

export const TextInput = ({ value = "", onChange, name, title, number, placeholder, disabled }) => {
  return (
    <FormItem
      row
      colon={false}
      label={
        title ? (
          <Typography
            variant="subtitle1"
            style={{ fontWeight: "bold" }}
          >
            {number} {title}
          </Typography>
        ) : null
      }
    >
      <TextField
        variant="outlined"
        style={{ width: "100%", background: "#fff" }}
        value={value}
        size="small"
        placeholder={placeholder}
        onChange={onChange}
        name={name}
        disabled={disabled}
      />
    </FormItem>
  )
}

export const ImageUploader = ({ value, onChange, name, title, number, loading }) => {
  const { t } = useTranslation()
  const handleChange = (s3Path) => {
    onChange({
      target: {
        name: name,
        value: s3Path
      }
    })
  }

  return (
    <>
      <FormItem
        row
        colon={false}
        label={
          title ? (
            <Box display="flex" alignItems="center">
              <Typography
                variant="subtitle1"
                style={{ fontWeight: "bold" }}
              >
                {number} {title}
              </Typography>
              <Tooltip title={t({ defaultMessage: "上传的图档会储存在nubis drive中的档案浏览，档案损坏或删除会导致图片载入失败" })}>
                <HelpOutline fontSize="10px" />
              </Tooltip>
            </Box>
          ) : null
        }
      >
        <UpdateIcon value={value} onChange={handleChange} loading={loading} />
      </FormItem>
    </>
  );
};